function seededShuffle<T>(array: T[], seed: number): T[] {
  const result = [...array];
  let currentSeed = seed;

  const random = () => {
    currentSeed = (currentSeed * 1103515245 + 12345) & 0x7fffffff;
    return currentSeed / 0x7fffffff;
  };

  for (let i = result.length - 1; i > 0; i--) {
    const j = Math.floor(random() * (i + 1));
    [result[i], result[j]] = [result[j], result[i]];
  }

  return result;
}

const rawQuestions = [
  // AMBITION
  {
    id: 'amb1',
    characteristicId: 'ambition',
    text: 'In the past three months, I have proactively sought out new opportunities.',
    reversed: false
  },
  {
    id: 'amb2',
    characteristicId: 'ambition',
    text: 'I often avoid setting goals that might be difficult to reach.',
    reversed: true
  },
  {
    id: 'amb3',
    characteristicId: 'ambition',
    text: 'When I accomplish a goal, I immediately set a higher one for myself.',
    reversed: false
  },
  {
    id: 'amb4',
    characteristicId: 'ambition',
    text: 'I struggle to stay motivated when faced with setbacks.',
    reversed: true
  },
  {
    id: 'amb5',
    characteristicId: 'ambition',
    text: 'I take initiative to push beyond what is expected of me in my career or personal life.',
    reversed: false
  },
  {
    id: 'amb6',
    characteristicId: 'ambition',
    text: 'I tend to settle for what is comfortable rather than pushing for greater achievements.',
    reversed: true
  },
  {
    id: 'amb7',
    characteristicId: 'ambition',
    text: 'I actively track my progress toward long-term objectives.',
    reversed: false
  },
  {
    id: 'amb8',
    characteristicId: 'ambition',
    text: 'I frequently hesitate to take action on my bigger ambitions.',
    reversed: true
  },
  {
    id: 'amb9',
    characteristicId: 'ambition',
    text: 'I have a clear vision of where I want to be in the future and work toward it.',
    reversed: false
  },
  {
    id: 'amb10',
    characteristicId: 'ambition',
    text: 'I sometimes procrastinate on setting meaningful goals.',
    reversed: true
  },
  {
    id: 'amb11',
    characteristicId: 'ambition',
    text: 'I am willing to make sacrifices to achieve my long-term goals.',
    reversed: false
  },
  {
    id: 'amb12',
    characteristicId: 'ambition',
    text: 'I allow external circumstances to dictate my level of motivation.',
    reversed: true
  },

  // BOLDNESS
  {
    id: 'bold1',
    characteristicId: 'boldness',
    text: 'Over the past three months, I have taken risks that could lead to meaningful rewards.',
    reversed: false
  },
  {
    id: 'bold2',
    characteristicId: 'boldness',
    text: 'I often wait for others to take action before making a decision.',
    reversed: true
  },
  {
    id: 'bold3',
    characteristicId: 'boldness',
    text: 'When I believe in something strongly, I speak up even in difficult situations.',
    reversed: false
  },
  {
    id: 'bold4',
    characteristicId: 'boldness',
    text: 'I avoid unfamiliar situations because they make me uncomfortable.',
    reversed: true
  },
  {
    id: 'bold5',
    characteristicId: 'boldness',
    text: 'In the past three months, I have made choices that required stepping outside my comfort zone.',
    reversed: false
  },
  {
    id: 'bold6',
    characteristicId: 'boldness',
    text: 'I tend to second-guess myself when making bold decisions.',
    reversed: true
  },
  {
    id: 'bold7',
    characteristicId: 'boldness',
    text: 'I embrace new challenges as opportunities for growth rather than threats.',
    reversed: false
  },
  {
    id: 'bold8',
    characteristicId: 'boldness',
    text: 'I find myself avoiding situations where I might stand out too much.',
    reversed: true
  },
  {
    id: 'bold9',
    characteristicId: 'boldness',
    text: 'I take responsibility for making difficult decisions when needed.',
    reversed: false
  },
  {
    id: 'bold10',
    characteristicId: 'boldness',
    text: 'I hesitate to challenge conventional thinking, even when I disagree.',
    reversed: true
  },
  {
    id: 'bold11',
    characteristicId: 'boldness',
    text: 'I am willing to be the first to try something new, even if it carries some risk.',
    reversed: false
  },
  {
    id: 'bold12',
    characteristicId: 'boldness',
    text: 'I feel uncomfortable when I have to stand firm in my decisions despite opposition.',
    reversed: true
  },

  // INTEGRITY
  {
    id: 'int1',
    characteristicId: 'integrity',
    text: 'I have stood by my principles, even when it was difficult, in the past three months.',
    reversed: false
  },
  {
    id: 'int2',
    characteristicId: 'integrity',
    text: 'I sometimes bend my ethical standards when under pressure.',
    reversed: true
  },
  {
    id: 'int3',
    characteristicId: 'integrity',
    text: 'I take responsibility for my mistakes rather than blaming external factors.',
    reversed: false
  },
  {
    id: 'int4',
    characteristicId: 'integrity',
    text: 'I have knowingly broken a commitment when it was inconvenient.',
    reversed: true
  },
  {
    id: 'int5',
    characteristicId: 'integrity',
    text: 'In the past three months, I have made decisions based on my core values rather than short-term benefits.',
    reversed: false
  },
  {
    id: 'int6',
    characteristicId: 'integrity',
    text: 'I sometimes avoid admitting when I am wrong.',
    reversed: true
  },
  {
    id: 'int7',
    characteristicId: 'integrity',
    text: 'I have been honest with myself and others about my capabilities and limits.',
    reversed: false
  },
  {
    id: 'int8',
    characteristicId: 'integrity',
    text: 'I have exaggerated my achievements to gain approval.',
    reversed: true
  },
  {
    id: 'int9',
    characteristicId: 'integrity',
    text: 'I follow through on my commitments, even when it\'s difficult.',
    reversed: false
  },
  {
    id: 'int10',
    characteristicId: 'integrity',
    text: 'I have downplayed the contributions of others in a team effort.',
    reversed: true
  },
  {
    id: 'int11',
    characteristicId: 'integrity',
    text: 'I treat others fairly and consistently, even when it doesn\'t benefit me directly.',
    reversed: false
  },
  {
    id: 'int12',
    characteristicId: 'integrity',
    text: 'I have compromised my values in order to avoid conflict.',
    reversed: true
  },

  // POSITIVE OUTLOOK
  {
    id: 'pos1',
    characteristicId: 'positiveOutlook',
    text: 'When I faced a challenge in the last three months, I looked for positive aspects.',
    reversed: false
  },
  {
    id: 'pos2',
    characteristicId: 'positiveOutlook',
    text: 'I often assume that things will go wrong rather than right.',
    reversed: true
  },
  {
    id: 'pos3',
    characteristicId: 'positiveOutlook',
    text: 'I focus on finding solutions rather than dwelling on problems.',
    reversed: false
  },
  {
    id: 'pos4',
    characteristicId: 'positiveOutlook',
    text: 'I frequently expect the worst possible outcome.',
    reversed: true
  },
  {
    id: 'pos5',
    characteristicId: 'positiveOutlook',
    text: 'In difficult situations, I remind myself that things can improve with time and effort.',
    reversed: false
  },
  {
    id: 'pos6',
    characteristicId: 'positiveOutlook',
    text: 'I tend to view setbacks as permanent rather than temporary.',
    reversed: true
  },
  {
    id: 'pos7',
    characteristicId: 'positiveOutlook',
    text: 'I maintain enthusiasm when starting new projects or experiences.',
    reversed: false
  },
  {
    id: 'pos8',
    characteristicId: 'positiveOutlook',
    text: 'I often struggle to see silver linings in difficult situations.',
    reversed: true
  },
  {
    id: 'pos9',
    characteristicId: 'positiveOutlook',
    text: 'I believe in my ability to overcome obstacles and improve my circumstances.',
    reversed: false
  },
  {
    id: 'pos10',
    characteristicId: 'positiveOutlook',
    text: 'I get discouraged easily when things don\'t go as planned.',
    reversed: true
  },
  {
    id: 'pos11',
    characteristicId: 'positiveOutlook',
    text: 'I trust that things will generally work out, even in difficult moments.',
    reversed: false
  },
  {
    id: 'pos12',
    characteristicId: 'positiveOutlook',
    text: 'I often feel that my efforts will not make a difference in the long run.',
    reversed: true
  },

  // DYNAMIC ENERGY (passion)
  {
    id: 'pas1',
    characteristicId: 'passion',
    text: 'I feel energized when working on things I care about.',
    reversed: false
  },
  {
    id: 'pas2',
    characteristicId: 'passion',
    text: 'I frequently feel drained by my daily responsibilities.',
    reversed: true
  },
  {
    id: 'pas3',
    characteristicId: 'passion',
    text: 'I maintain high energy levels when pursuing my goals.',
    reversed: false
  },
  {
    id: 'pas4',
    characteristicId: 'passion',
    text: 'I often lose interest quickly in new projects.',
    reversed: true
  },
  {
    id: 'pas5',
    characteristicId: 'passion',
    text: 'I am enthusiastic about learning and growing.',
    reversed: false
  },
  {
    id: 'pas6',
    characteristicId: 'passion',
    text: 'I struggle to sustain motivation over long periods.',
    reversed: true
  },
  {
    id: 'pas7',
    characteristicId: 'passion',
    text: 'I inspire others with my enthusiasm and drive.',
    reversed: false
  },
  {
    id: 'pas8',
    characteristicId: 'passion',
    text: 'I find it hard to stay passionate about my work.',
    reversed: true
  },
  {
    id: 'pas9',
    characteristicId: 'passion',
    text: 'I actively seek activities that excite me and keep me engaged.',
    reversed: false
  },
  {
    id: 'pas10',
    characteristicId: 'passion',
    text: 'I avoid challenging work because it feels exhausting.',
    reversed: true
  },
  {
    id: 'pas11',
    characteristicId: 'passion',
    text: 'I put my heart into what I do.',
    reversed: false
  },
  {
    id: 'pas12',
    characteristicId: 'passion',
    text: 'I often go through the motions without real enthusiasm.',
    reversed: true
  },

  // SOCIABILITY
  {
    id: 'soc1',
    characteristicId: 'sociability',
    text: 'I build rapport easily with new people.',
    reversed: false
  },
  {
    id: 'soc2',
    characteristicId: 'sociability',
    text: 'I often feel uncomfortable in social gatherings.',
    reversed: true
  },
  {
    id: 'soc3',
    characteristicId: 'sociability',
    text: 'I contribute effectively in group discussions.',
    reversed: false
  },
  {
    id: 'soc4',
    characteristicId: 'sociability',
    text: 'I find it difficult to start conversations with strangers.',
    reversed: true
  },
  {
    id: 'soc5',
    characteristicId: 'sociability',
    text: 'I engage effectively in team settings.',
    reversed: false
  },
  {
    id: 'soc6',
    characteristicId: 'sociability',
    text: 'I struggle to maintain long-term relationships.',
    reversed: true
  },
  {
    id: 'soc7',
    characteristicId: 'sociability',
    text: 'I network and connect with people regularly.',
    reversed: false
  },
  {
    id: 'soc8',
    characteristicId: 'sociability',
    text: 'I prefer to keep to myself in professional settings.',
    reversed: true
  },
  {
    id: 'soc9',
    characteristicId: 'sociability',
    text: 'I actively create inclusive environments.',
    reversed: false
  },
  {
    id: 'soc10',
    characteristicId: 'sociability',
    text: 'I tend to avoid social interactions unless required.',
    reversed: true
  },
  {
    id: 'soc11',
    characteristicId: 'sociability',
    text: 'I adapt well to different social contexts.',
    reversed: false
  },
  {
    id: 'soc12',
    characteristicId: 'sociability',
    text: 'I find it challenging to connect with people from diverse backgrounds.',
    reversed: true
  },

  // COMMUNICATION
  {
    id: 'com1',
    characteristicId: 'communication',
    text: 'I express my thoughts clearly and concisely.',
    reversed: false
  },
  {
    id: 'com2',
    characteristicId: 'communication',
    text: 'I often struggle to articulate my ideas effectively.',
    reversed: true
  },
  {
    id: 'com3',
    characteristicId: 'communication',
    text: 'I listen actively and seek to understand others.',
    reversed: false
  },
  {
    id: 'com4',
    characteristicId: 'communication',
    text: 'I frequently interrupt others when speaking.',
    reversed: true
  },
  {
    id: 'com5',
    characteristicId: 'communication',
    text: 'I adjust my communication style to different audiences.',
    reversed: false
  },
  {
    id: 'com6',
    characteristicId: 'communication',
    text: 'I avoid difficult conversations whenever possible.',
    reversed: true
  },
  {
    id: 'com7',
    characteristicId: 'communication',
    text: 'I provide constructive feedback effectively.',
    reversed: false
  },
  {
    id: 'com8',
    characteristicId: 'communication',
    text: 'I tend to misunderstand others due to poor listening.',
    reversed: true
  },
  {
    id: 'com9',
    characteristicId: 'communication',
    text: 'I ensure my message is understood correctly.',
    reversed: false
  },
  {
    id: 'com10',
    characteristicId: 'communication',
    text: 'I struggle to express my thoughts under pressure.',
    reversed: true
  },
  {
    id: 'com11',
    characteristicId: 'communication',
    text: 'I communicate with empathy and respect.',
    reversed: false
  },
  {
    id: 'com12',
    characteristicId: 'communication',
    text: 'I find it difficult to adapt my communication style.',
    reversed: true
  },

  // JUDGMENT (wisdom)
  {
    id: 'wis1',
    characteristicId: 'wisdom',
    text: 'I carefully evaluate multiple perspectives before making decisions.',
    reversed: false
  },
  {
    id: 'wis2',
    characteristicId: 'wisdom',
    text: 'I tend to make impulsive choices without fully considering the consequences.',
    reversed: true
  },
  {
    id: 'wis3',
    characteristicId: 'wisdom',
    text: 'I balance emotion with reason in decision-making.',
    reversed: false
  },
  {
    id: 'wis4',
    characteristicId: 'wisdom',
    text: 'I often ignore long-term consequences in favor of short-term comfort.',
    reversed: true
  },
  {
    id: 'wis5',
    characteristicId: 'wisdom',
    text: 'I learn from past experiences and apply those lessons to new situations.',
    reversed: false
  },
  {
    id: 'wis6',
    characteristicId: 'wisdom',
    text: 'I struggle to recognize patterns in complex situations.',
    reversed: true
  },
  {
    id: 'wis7',
    characteristicId: 'wisdom',
    text: 'I actively seek advice from those with more experience before making major decisions.',
    reversed: false
  },
  {
    id: 'wis8',
    characteristicId: 'wisdom',
    text: 'I tend to act without gathering enough information.',
    reversed: true
  },
  {
    id: 'wis9',
    characteristicId: 'wisdom',
    text: 'I consider ethical implications when making important choices.',
    reversed: false
  },
  {
    id: 'wis10',
    characteristicId: 'wisdom',
    text: 'I have difficulty distinguishing between urgent and important matters.',
    reversed: true
  },
  {
    id: 'wis11',
    characteristicId: 'wisdom',
    text: 'I can see beyond immediate circumstances to anticipate future trends.',
    reversed: false
  },
  {
    id: 'wis12',
    characteristicId: 'wisdom',
    text: 'I frequently make decisions based on impulse rather than thoughtful analysis.',
    reversed: true
  },

  // LEARNING
  {
    id: 'lrn1',
    characteristicId: 'learning',
    text: 'I actively seek out new knowledge and skills on a regular basis.',
    reversed: false
  },
  {
    id: 'lrn2',
    characteristicId: 'learning',
    text: 'I resist learning new things when they require significant effort.',
    reversed: true
  },
  {
    id: 'lrn3',
    characteristicId: 'learning',
    text: 'I embrace feedback as an opportunity to improve.',
    reversed: false
  },
  {
    id: 'lrn4',
    characteristicId: 'learning',
    text: 'I struggle to see the value in learning from past mistakes.',
    reversed: true
  },
  {
    id: 'lrn5',
    characteristicId: 'learning',
    text: 'I dedicate time to personal development and self-improvement.',
    reversed: false
  },
  {
    id: 'lrn6',
    characteristicId: 'learning',
    text: 'I tend to avoid challenges that require me to develop new skills.',
    reversed: true
  },
  {
    id: 'lrn7',
    characteristicId: 'learning',
    text: 'I apply new knowledge to practical situations.',
    reversed: false
  },
  {
    id: 'lrn8',
    characteristicId: 'learning',
    text: 'I often ignore advice that contradicts my current beliefs.',
    reversed: true
  },
  {
    id: 'lrn9',
    characteristicId: 'learning',
    text: 'I stay current with developments in my field of interest.',
    reversed: false
  },
  {
    id: 'lrn10',
    characteristicId: 'learning',
    text: 'I avoid learning opportunities that push me out of my comfort zone.',
    reversed: true
  },
  {
    id: 'lrn11',
    characteristicId: 'learning',
    text: 'I seek mentorship and guidance to accelerate my growth.',
    reversed: false
  },
  {
    id: 'lrn12',
    characteristicId: 'learning',
    text: 'I rarely reflect on my past experiences to extract meaningful lessons.',
    reversed: true
  },

  // CREATIVITY
  {
    id: 'cre1',
    characteristicId: 'creativity',
    text: 'I generate innovative solutions to problems.',
    reversed: false
  },
  {
    id: 'cre2',
    characteristicId: 'creativity',
    text: 'I find it difficult to think outside of conventional boundaries.',
    reversed: true
  },
  {
    id: 'cre3',
    characteristicId: 'creativity',
    text: 'I enjoy experimenting with new approaches to familiar tasks.',
    reversed: false
  },
  {
    id: 'cre4',
    characteristicId: 'creativity',
    text: 'I avoid unconventional ideas because they feel risky.',
    reversed: true
  },
  {
    id: 'cre5',
    characteristicId: 'creativity',
    text: 'I challenge traditional assumptions to explore fresh perspectives.',
    reversed: false
  },
  {
    id: 'cre6',
    characteristicId: 'creativity',
    text: 'I hesitate to share original ideas in group settings.',
    reversed: true
  },
  {
    id: 'cre7',
    characteristicId: 'creativity',
    text: 'I bring creative insights to discussions and collaborations.',
    reversed: false
  },
  {
    id: 'cre8',
    characteristicId: 'creativity',
    text: 'I struggle to come up with unique solutions when faced with challenges.',
    reversed: true
  },
  {
    id: 'cre9',
    characteristicId: 'creativity',
    text: 'I adapt existing ideas in novel ways.',
    reversed: false
  },
  {
    id: 'cre10',
    characteristicId: 'creativity',
    text: 'I prefer routine tasks over exploring new possibilities.',
    reversed: true
  },
  {
    id: 'cre11',
    characteristicId: 'creativity',
    text: 'I enjoy imagining and brainstorming new concepts.',
    reversed: false
  },
  {
    id: 'cre12',
    characteristicId: 'creativity',
    text: 'I find it challenging to think of alternative ways to do things.',
    reversed: true
  },

  // ADAPTABILITY (flexibility)
  {
    id: 'flex1',
    characteristicId: 'flexibility',
    text: 'I adapt well to unexpected changes.',
    reversed: false
  },
  {
    id: 'flex2',
    characteristicId: 'flexibility',
    text: 'I feel uncomfortable when my plans change suddenly.',
    reversed: true
  },
  {
    id: 'flex3',
    characteristicId: 'flexibility',
    text: 'I remain productive in uncertain situations.',
    reversed: false
  },
  {
    id: 'flex4',
    characteristicId: 'flexibility',
    text: 'I resist changing my routine even when it\'s necessary.',
    reversed: true
  },
  {
    id: 'flex5',
    characteristicId: 'flexibility',
    text: 'I pivot strategies when circumstances shift.',
    reversed: false
  },
  {
    id: 'flex6',
    characteristicId: 'flexibility',
    text: 'I get frustrated when things don\'t go as planned.',
    reversed: true
  },
  {
    id: 'flex7',
    characteristicId: 'flexibility',
    text: 'I embrace new ways of working without hesitation.',
    reversed: false
  },
  {
    id: 'flex8',
    characteristicId: 'flexibility',
    text: 'I struggle to adjust my mindset when faced with new challenges.',
    reversed: true
  },
  {
    id: 'flex9',
    characteristicId: 'flexibility',
    text: 'I remain composed under pressure and adapt accordingly.',
    reversed: false
  },
  {
    id: 'flex10',
    characteristicId: 'flexibility',
    text: 'I avoid trying new approaches because I fear failure.',
    reversed: true
  },
  {
    id: 'flex11',
    characteristicId: 'flexibility',
    text: 'I seek opportunities to develop new skills and perspectives.',
    reversed: false
  },
  {
    id: 'flex12',
    characteristicId: 'flexibility',
    text: 'I resist feedback that suggests I should change my approach.',
    reversed: true
  },

  // VISIONARY THINKING
  {
    id: 'vis1',
    characteristicId: 'visionaryThinking',
    text: 'I can clearly envision long-term possibilities and goals.',
    reversed: false
  },
  {
    id: 'vis2',
    characteristicId: 'visionaryThinking',
    text: 'I rarely think about the future beyond my immediate needs.',
    reversed: true
  },
  {
    id: 'vis3',
    characteristicId: 'visionaryThinking',
    text: 'I connect current actions to long-term success.',
    reversed: false
  },
  {
    id: 'vis4',
    characteristicId: 'visionaryThinking',
    text: 'I struggle to see the bigger picture in decision-making.',
    reversed: true
  },
  {
    id: 'vis5',
    characteristicId: 'visionaryThinking',
    text: 'I anticipate future trends and developments before they happen.',
    reversed: false
  },
  {
    id: 'vis6',
    characteristicId: 'visionaryThinking',
    text: 'I find it difficult to plan for long-term success.',
    reversed: true
  },
  {
    id: 'vis7',
    characteristicId: 'visionaryThinking',
    text: 'I inspire others with my forward-thinking mindset.',
    reversed: false
  },
  {
    id: 'vis8',
    characteristicId: 'visionaryThinking',
    text: 'I avoid setting ambitious future goals because they seem unrealistic.',
    reversed: true
  },
  {
    id: 'vis9',
    characteristicId: 'visionaryThinking',
    text: 'I develop detailed plans for my future aspirations.',
    reversed: false
  },
  {
    id: 'vis10',
    characteristicId: 'visionaryThinking',
    text: 'I struggle to articulate a clear vision for my life.',
    reversed: true
  },
  {
    id: 'vis11',
    characteristicId: 'visionaryThinking',
    text: 'I challenge conventional thinking to create new opportunities.',
    reversed: false
  },
  {
    id: 'vis12',
    characteristicId: 'visionaryThinking',
    text: 'I hesitate to explore new ideas because they seem too abstract.',
    reversed: true
  }
];

export const questions = seededShuffle(rawQuestions, 42);

// Verify we have exactly 144 questions
console.assert(
  questions.length === 144,
  `Expected 144 questions, but got ${questions.length}`
);

// Verify we have 12 questions for each characteristic
const characteristicCounts = questions.reduce((acc, q) => {
  acc[q.characteristicId] = (acc[q.characteristicId] || 0) + 1;
  return acc;
}, {} as Record<string, number>);

Object.entries(characteristicCounts).forEach(([characteristicId, count]) => {
  console.assert(
    count === 12,
    `Expected 12 questions for ${characteristicId}, but got ${count}`
  );
});